// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZtII1","title":"styles_title__1cf9G"};